// extracted by mini-css-extract-plugin
export default {"body":"styles_body__JGUE2","agreement-footer":"styles_agreement-footer__BcqLK"};